import { DatePickerProps, Form, Typography } from 'antd';
import { Checkbox, DatePicker, Space } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

interface IShip {
  shippingPlanEtd?: Date;
  shippingPlanEta?: Date;
  onChange?: any;
  onChange2?: any;
  flag?: Boolean;
  flagCheck?: Boolean;
  isDisabled?: Boolean;
}

function ShippingPlant({
  shippingPlanEtd,
  shippingPlanEta,
  onChange,
  onChange2,
  flag,
  flagCheck,
  isDisabled
}: IShip) {
  const [dateETD, setdateETD] = useState('' as any);
  const [dateETA, setdateETA] = useState('' as any);
  const [checkedTBA, setCheckedTBA] = useState(!shippingPlanEtd && !shippingPlanEta);

  useEffect(() => {
    if ((!shippingPlanEtd && !shippingPlanEta)) {
      setCheckedTBA(false);
    }
  }, [shippingPlanEtd, shippingPlanEta]);

  const disabled = isDisabled === undefined ? true : Boolean(isDisabled);
  const { Text } = Typography;
  useEffect(() => {
    setdateETD(
      dateETD && shippingPlanEtd
        ? dateETD
        : shippingPlanEtd
        ? shippingPlanEtd.toString()
        : ''
    );
  }, [shippingPlanEtd]);

  useEffect(() => {
    setdateETA(
      dateETA && shippingPlanEta
        ? dateETA
        : shippingPlanEta
        ? shippingPlanEta.toString()
        : ''
    );
  }, [shippingPlanEta]);
  const dateFormat = 'YYYY/MM/DD';
  const { RangePicker } = DatePicker;
  const onChangeEta: DatePickerProps['onChange'] = (date, dateStringEta) => {
    shippingPlanEtd = new Date(dateStringEta);
    setdateETA(dateStringEta);
    onChange(dateStringEta, dateETD);
  };
  const onChangeEtd: DatePickerProps['onChange'] = (date, dateStringEtd) => {
    shippingPlanEta = new Date(dateStringEtd);
    setdateETD(dateStringEtd);
    onChange(dateETA, dateStringEtd);
  };

  const [form] = Form.useForm();

  form.setFieldsValue({
    Picker: [
      moment(moment(shippingPlanEtd).utc().format('YYYY-MM-DD')),
      moment(moment(shippingPlanEta).utc().format('YYYY-MM-DD'))
    ]
  });

  return (
    <>
      {flag ? (
        <div className="shippingPlant" style={{ height: '130px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '15px'
            }}
          >
            <p>Shipping Plan</p>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '10px'
            }}
          >
            <div className="wrapETD" style={{}}>
              <Space direction="vertical">
                <span>ETD</span>
                <DatePicker
                  defaultValue={moment(
                    moment(new Date()).toString(),
                    dateFormat
                  )}
                  value={moment(
                    moment(dateETD ? dateETD : new Date())
                      .format('YYYY.MM.DD')
                      .toString(),
                    dateFormat
                  )}
                  format={dateFormat}
                  onChange={onChangeEtd}
                  disabledDate={(current: any) => {
                    return new Date(current).getTime() - new Date().getTime() >
                      0
                      ? false
                      : true;
                  }}
                />
              </Space>
            </div>
            <span style={{ display: 'flex', alignItems: 'flex-end' }}>~</span>
            <div className="wrapETA">
              <Space direction="vertical">
                <span>ETA</span>
                <DatePicker
                  value={moment(
                    moment(dateETA ? dateETA : new Date())
                      .format('YYYY.MM.DD')
                      .toString(),
                    dateFormat
                  )}
                  format={dateFormat}
                  onChange={onChangeEta}
                  disabledDate={(current: any) => {
                    return new Date(current).getTime() - new Date().getTime() >
                      0
                      ? false
                      : true;
                  }}
                />
              </Space>
            </div>
          </div>
        </div>
      ) : (
        <div className="shippingPlant" style={{ height: '130px' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '15px'
            }}
          >
            <p>Shipping Plan</p>
            {flagCheck ? (
              ''
            ) : (
              <Checkbox
                checked={checkedTBA}
                disabled={disabled}
                onChange={(event) => {
                  setCheckedTBA(event.target.checked);
                  if (event.target.checked) {
                    setdateETD(null);
                    setdateETA(null);
                    onChange2({ shippingPlanEtd: '', shippingPlanEta: '' });
                  }
                }}
              >
                TBA
              </Checkbox>
            )}
          </div>
          <div className="datetime-shipping">
            <Form form={form}>
              <p style={{ marginBottom: '10px' }}>ETD - ETA </p>
              {/* <Form.Item name="Picker"> */}
              <RangePicker
                value={[
                  dateETD ? moment(dateETD) : null,
                  dateETA ? moment(dateETA) : null
                ]}
                style={{ width: '100%' }}
                format={dateFormat}
                disabled={disabled || (!disabled && checkedTBA)}
                clearIcon={false}
                onChange={(_, date) => {
                  const [shippingPlanEtd, shippingPlanEta] = date;
                  setdateETD(shippingPlanEtd);
                  setdateETA(shippingPlanEta);
                  onChange2({ shippingPlanEtd, shippingPlanEta });
                }}
              />
              {/* </Form.Item> */}
            </Form>
          </div>
        </div>
      )}
    </>
  );
}

export default ShippingPlant;
